<script>
    import { _ } from 'svelte-i18n';
    // `kind` drives the screen-reader label: 'action' => a reward is waiting to be
    // claimed, 'new' => unseen content. i18n keys fall back to English if absent.
    let { kind = 'new' } = $props();
    let labelKey = $derived(kind === 'action' ? 'NotificationRewardAvailable' : 'NotificationNewContent');
    let fallback = $derived(kind === 'action' ? 'Reward available' : 'New');
</script>

<span class="notif-dot" aria-hidden="true"></span>
<span class="sr-only">{$_(labelKey, { default: fallback })}</span>

<style lang="scss">
  .notif-dot {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #ff2d2d;
    // White ring so it reads on both the dark desktop pills and brown mobile bar.
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.9), 0 1px 2px rgba(0, 0, 0, 0.5);
    pointer-events: none;
    z-index: 2;
  }
  // Every seasonal theme paints `.<theme> .tabs span` (0,2,1) to colour the tab pills, and this
  // dot is a span inside a tab, so under a theme it showed as an empty white ring. The extra
  // `.tabs` ancestor (0,3,0) keeps it red whichever stylesheet loads last.
  :global(.tabs) .notif-dot {
    background: #ff2d2d;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
</style>
